"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableHeaderSettingsBehavior = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_pop_over_behavior_1 = require("../../../atoms/bc-pop-over/bc-pop-over-behavior");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableHeaderSettingsBehavior = (function () {
    function BcDataTableHeaderSettingsBehavior(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.bcPopOverBehavior = new bc_pop_over_behavior_1.BcPopOverBehavior();
    }
    BcDataTableHeaderSettingsBehavior.prototype.init = function (headerDiv) {
        var divHeaderSettings = headerDiv.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SETTINGS_CLASS)[0];
        var headerSettingsHtml = this.setHeaderSettings(divHeaderSettings);
        this.initComponentsInHeaderSettings(headerSettingsHtml);
    };
    BcDataTableHeaderSettingsBehavior.prototype.generateRandomIdNumber = function () {
        return window.crypto.getRandomValues(new Uint32Array(1))[0];
    };
    BcDataTableHeaderSettingsBehavior.prototype.setHeaderSettings = function (divHeaderSettings) {
        var popOverId = 'pop-over-' + this.generateRandomIdNumber();
        var htmlPopOverSection = this.createHtmlPopOverSections(popOverId);
        divHeaderSettings.appendChild(htmlPopOverSection);
        var htmlPopOverIcon = this.createHtmlPopOverIcon(popOverId);
        divHeaderSettings.appendChild(htmlPopOverIcon);
        return divHeaderSettings;
    };
    BcDataTableHeaderSettingsBehavior.prototype.initComponentsInHeaderSettings = function (headerSettingsHtml) {
        var headerSettingsPopOver = headerSettingsHtml.querySelector(".".concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS));
        this.bcPopOverBehavior.setId(headerSettingsPopOver.id);
        this.bcPopOverBehavior.setUp();
    };
    BcDataTableHeaderSettingsBehavior.prototype.createHtmlPopOverSections = function (popOverId) {
        var popOverSectionElement = this.createSectionElement(popOverId);
        var innerSectionElement = this.createInnerSectionElement();
        var innerSectionContent = this.createSectionContent();
        innerSectionElement.appendChild(innerSectionContent);
        popOverSectionElement.appendChild(innerSectionElement);
        return popOverSectionElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype.createSectionElement = function (popOverId) {
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.setAttribute(common_constants_1.BcCommonConstants.ROLE, bc_data_table_constants_1.BcDataTableConstansts.DIALOG);
        sectionElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.WIDTH, bc_data_table_constants_1.BcDataTableConstansts.DIALOG_DEFAULT_WIDTH.toString());
        sectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS);
        sectionElement.id = popOverId;
        return sectionElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype.createInnerSectionElement = function () {
        var innerSectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        innerSectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CONTAINER_CLASS);
        return innerSectionElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype.createHtmlPopOverIcon = function (popOverId) {
        var emElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        emElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CONTROL, popOverId);
        emElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ARIA_DESCRIBED_BY, popOverId);
        emElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.ICON_CLASS, bc_data_table_constants_1.BcDataTableConstansts.MD_CLASS, bc_data_table_constants_1.BcDataTableConstansts.TARGET_CLASS, bc_data_table_constants_1.BcDataTableConstansts.POPOVER_TARGET_CLASS, bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_CLASS);
        emElement.textContent = bc_data_table_constants_1.BcDataTableConstansts.SETTINGS_TEXT;
        emElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.toogleDataTableSettings.bind(this));
        return emElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype.toogleDataTableSettings = function (event) {
        this.bcPopOverBehavior.tooglePopOver();
    };
    BcDataTableHeaderSettingsBehavior.prototype.createSectionContent = function () {
        var containerDiv = document.createElement('div');
        containerDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_CONTAINER_CLASS);
        var headerDiv = this.createHeaderSection();
        var mainDiv = this.createMainSection();
        var footerDiv = this.createFooterSection();
        containerDiv.appendChild(headerDiv);
        containerDiv.appendChild(mainDiv);
        containerDiv.appendChild(footerDiv);
        return containerDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype.createHeaderSection = function () {
        var headerDiv = document.createElement(bc_data_table_constants_1.BcDataTableConstansts.HEADER);
        headerDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_CONTAINER_CLASS);
        var titleH6 = document.createElement(common_constants_1.BcCommonConstants.H6_TAG);
        titleH6.textContent = bc_data_table_constants_1.BcDataTableConstansts.CONFIGURAR_TABLA_TEXT;
        var descriptionDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        descriptionDiv.textContent = bc_data_table_constants_1.BcDataTableConstansts.DESCRIPTION_TEXT;
        headerDiv.appendChild(titleH6);
        headerDiv.appendChild(descriptionDiv);
        return headerDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype.createMainSection = function () {
        var _this = this;
        var mainDiv = document.createElement(bc_data_table_constants_1.BcDataTableConstansts.MAIN_TAG);
        this.bcDataTableConfig.columnHeaders.data.forEach(function (columHeader, columnHeaderIndex) {
            var rowDiv = _this.createRowSection(columHeader, columnHeaderIndex);
            mainDiv.appendChild(rowDiv);
        });
        return mainDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype.createRowSection = function (columHeader, columnHeaderIndex) {
        var rowDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        rowDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_BETWEEN_CLASS);
        var nameColumn = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var nameColumnLabel = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        nameColumnLabel.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_CONTAINER_MAIN_LABEL_CLASS);
        nameColumnLabel.textContent = columHeader.name;
        nameColumn.appendChild(nameColumnLabel);
        var div3 = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        div3.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.DIRECTION_ROW_REVERSE_CLASS, bc_data_table_constants_1.BcDataTableConstansts.ROW_BORDER_CLASS);
        var div4 = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        div4.appendChild(this.createSettingCheckbox(columHeader, columnHeaderIndex));
        var div5 = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        div5.appendChild(this.addPinnedIcon(columHeader, columnHeaderIndex));
        div3.appendChild(div4);
        div3.appendChild(div5);
        rowDiv.appendChild(nameColumn);
        rowDiv.appendChild(div3);
        return rowDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype.addPinnedIcon = function (columHeader, columnHeaderIndex) {
        var iconElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        iconElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        iconElement.innerHTML = bc_data_table_constants_1.BcDataTableConstansts.ICON_THUMBTACK;
        return iconElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype.createSettingCheckbox = function (columHeader, columnHeaderIndex) {
        var checkboxElement = this.getCheckbox();
        var inputCheckbox = checkboxElement.querySelector(common_constants_1.BcCommonConstants.INPUT_CHECKBOX_TAG);
        inputCheckbox.id = 'column-header-settings-' + columnHeaderIndex;
        return checkboxElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype.getCheckbox = function () {
        var labelElement = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        labelElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_CONTAINER_CLASS);
        var checkboxElement = document.createElement(common_constants_1.BcCommonConstants.INPUT_TAG);
        checkboxElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_TYPE, bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_TEXT);
        var spanElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        spanElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_CLASS);
        labelElement.appendChild(checkboxElement);
        labelElement.appendChild(spanElement);
        return labelElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype.createFooterSection = function () {
        var footerDiv = document.createElement('footer');
        var applyButton = document.createElement('button');
        applyButton.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BUTTON_PRIMARY_CLASS, bc_data_table_constants_1.BcDataTableConstansts.BUTTON_SMALL_CLASS);
        applyButton.textContent = bc_data_table_constants_1.BcDataTableConstansts.BUTTON_APPLY_TEXT;
        var resetLink = document.createElement('a');
        resetLink.classList.add(bc_data_table_constants_1.BcDataTableConstansts.LINK_CLASS, bc_data_table_constants_1.BcDataTableConstansts.LINK_SMALL, bc_data_table_constants_1.BcDataTableConstansts.LINK_UNDERLINE);
        resetLink.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.TYPELINK_ATTRIBUTE, bc_data_table_constants_1.BcDataTableConstansts.UNDERLINE);
        resetLink.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.SIZELINK_ATTRIBUTE, common_constants_1.BcCommonConstants.SMALL);
        resetLink.innerHTML = bc_data_table_constants_1.BcDataTableConstansts.RESETLINK_TEXT;
        footerDiv.appendChild(applyButton);
        footerDiv.appendChild(resetLink);
        return footerDiv;
    };
    return BcDataTableHeaderSettingsBehavior;
}());
exports.BcDataTableHeaderSettingsBehavior = BcDataTableHeaderSettingsBehavior;
